import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import {
  Button,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { useStylesTF, useStylesTD, useStylesSetting } from "../../../../St/comps/UseStyle";
import { useStylesLbl } from "../../../../St/Reports/UseStyle";
import axios from "axios";
import { uri } from "../../../../help/Api";
import toast from "react-hot-toast";
import { sto } from "../../../../Context/InshData";

export default function GroupsForm(props) {
  const { object, groups, onChange, Employees, printers, color, setColor,PermType,  intColor,
    setIntColor ,formType,selectRow} = props;
  const clasTF = useStylesTF();
  const clasTD = useStylesTD();
  const onChangeData = (prop) => (event) => {
    onChange(event, { name: prop, value: event.target.value });
  };

  const hadleColorChange = (prop) => (event) => {

    setColor(event.target.value);
    const intCo=parseInt(color.replace("#",""),16);
    onChange(event, { name: "color", value:intCo });

    setIntColor(intCo);
  };

  const claslbl = useStylesLbl();

  const classesStt = useStylesSetting();

  const [submiting, setSubmiting] = useState(false);

  const applyDiscGroup = async () => {
    console.log(object);
    // const data = { id: taxGroupId };
    const data={...object,db_name: sto?.db_name}
    setSubmiting(true);
    await axios
      .post(uri + "Groups/applyDisc", data)
      .then((res) => {
        toast.success("تم تطبيق discount  على جميع الاصناف");
      })
      .catch((err) => {
        toast.error("لم يتم التطبيق حدثت مشكلة");
        console.log(err);
      });

    setSubmiting(false);
  };

  return (
    <React.Fragment>
      <Grid item lg={6} md={6} xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          id={"name"}
          label={" مجموعة الصنف "}
          className={clasTF.rootSale}
          InputProps={{ className: clasTD.input }}
          type="text"
          name={"name"}
          value={object.name}
          onChange={onChangeData("name")}
        />
      </Grid>
      <Grid item lg={6} md={6} xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          id={"nameEN"}
          label={"المجموعة (EN)"}
          className={clasTF.rootSale}
          InputProps={{ className: clasTD.input }}
          type="text"
          name={"nameEN"}
          value={object.nameEN}
          onChange={onChangeData("nameEN")}
        />
      </Grid>
      <Grid item lg={6} md={6} xs={12}>
        <RadioGroup
          row
          onChange={onChangeData("type")}
          value={object.type}
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
        >
          <FormControlLabel value="main" control={<Radio />} label="رئيسية " />
          <FormControlLabel value="sub" control={<Radio />} label="فرعية " />
        </RadioGroup>
      </Grid>
      <Grid item lg={6} md={6} xs={12}>
        <Autocomplete // classes={clasAo}
          value={object.parent}
          onChange={(event, newValue) => {
            onChange(null, { name: "parent", value: newValue });
          }}
          id="controllable-states-dem"
          size="small"
          options={groups}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          //style={{  }}  // disabled={}
          disabled={object.type == "main"}
          disableClearable
          renderInput={(params) => (
            <TextField
              id="valuePricePay"
              {...params}
              label={"المجموعة الأب "}
              variant="outlined"
              size="small"
            />
          )}
        />
      </Grid>
      <Grid item lg={3} md={3} xs={6}>
        <TextField
          type="number"
          fullWidth
          // disabled={object.discount != 0}
          variant="outlined"
          size="small"
          id="amount_disc"
          label="الخصم مبلغ"
          className={clasTF.root}
          InputProps={{ className: clasTF.input }}
          name="amount_disc"
          placeholder={"0"}
          InputLabelProps={{ shrink: true }}
          value={object.amount_disc ?? 0}
          onChange={onChangeData("amount_disc")}
        />
      </Grid>

      <Grid item lg={3} md={3} xs={6}>
        <TextField
          type="number"
          fullWidth
          // disabled={object.amount_disc != 0}
          variant="outlined"
          size="small"
          id="discount"
          label="% خصم نسبة"
          className={clasTF.root}
          InputProps={{ className: clasTF.input }}
          name="discount"
          placeholder={"0"}
          InputLabelProps={{ shrink: true }}
          value={object.discount ?? 0}
          onChange={onChangeData("discount")}
        />
      </Grid>
      {
        formType == "edit" && <Grid item lg={6} md={6} xs={12}>
          <Button
            variant="contained"
            className={classesStt.btn}
            color="red"
            fontSize="small"
            onClick={() => {
              applyDiscGroup();
            }}
           disabled={submiting}
          >
            {submiting
              ? "جاري تطبيق discount  ..."
              : "تطبيق discount على الاصناف"}
          </Button>
        </Grid>
      }

      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={6}>
        <Autocomplete
          multiple // classes={clasAo}
          value={object?.group_Emps}
          onChange={(event, newValue) => {
            const index = object?.group_Emps?.findIndex(
              (x) => x.name == event.target.textContent
            );
            // console.log("event", index);
            if (index == -1)
              onChange(null, { name: "group_Emps", value: newValue });
          }}
          id="controllable-states-dem"
          size="small"
          options={Employees}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          style={{ direction: "ltr" }} // disabled={}
          //disabled={statu Dis.pricePay}
          disableClearable
          renderInput={(params) => (
            <TextField
              id="valuePricePay"
              {...params}
              label={"عدم الإظهار على الموظف"}
              variant="outlined"
              size="small"
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Autocomplete
          value={object?.printer}
          onChange={(event, newValue) => {
            // console.log("event", index);
            onChange(null, { name: "printer", value: newValue });
          }}
          id="controllable-states-dem"
          size="small"
          options={printers}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          style={{ direction: "ltr" }} // disabled={}
          //disabled={statu Dis.pricePay}
          disableClearable
          renderInput={(params) => (
            <TextField
              id="valuePricePay"
              {...params}
              label={"حدد الطابعة"}
              variant="outlined"
              size="small"
            />
          )}
        />
      </Grid>
      {PermType[0]?.id === 3 && (
        <>
          <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id="color"
              label={"اللون"}
              InputLabelProps={{ className: claslbl.clrBlackLbl }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              type="color"
              name="color"
              value={color}
              onChange={hadleColorChange("color")}

            />
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id="text"
              label={"رمز اللون"}
              InputLabelProps={{ className: claslbl.clrBlackLbl }}
              InputProps={{ className: claslbl.clrBlackTxt,readOnly:true }}
              type="test"
              name="color"
              value={intColor}
              //onChange={hadleColorChange("color")}

            />
          </Grid>
        </>
      )}

    </React.Fragment>
  );
}
